import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedal = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.034 19.068L10 9H16L20 17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.966 19.068L30 9H24L20 17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 31C23.866 31 27 27.866 27 24C27 20.134 23.866 17 20 17C16.134 17 13 20.134 13 24C13 27.866 16.134 31 20 31Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 20.382L21.176 22.764L23.804 23.146L21.902 25L22.351 27.618L20 26.382L17.649 27.618L18.098 25L16.196 23.146L18.824 22.764L20 20.382Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgMedal);
export default ForwardRef;
